var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.19699 12.803C3.66099 14.268 5.58099 15 7.49999 15C9.23199 15 10.96 14.398 12.358 13.206L17.126 17.973L17.975 17.125L13.207 12.357C15.72 9.41 15.59 4.981 12.805 2.196C11.339 0.732 9.41899 0 7.49999 0C5.58099 0 3.66099 0.732 2.19699 2.197C-0.732006 5.126 -0.732006 9.874 2.19699 12.803ZM1.19999 7.5C1.19999 5.817 1.85599 4.235 3.04499 3.045C4.23399 1.855 5.81699 1.2 7.49999 1.2C9.18299 1.2 10.765 1.855 11.955 3.045C14.411 5.501 14.411 9.498 11.955 11.955C10.765 13.145 9.18299 13.8 7.49999 13.8C5.81699 13.8 4.23499 13.145 3.04499 11.955C1.85499 10.765 1.19999 9.183 1.19999 7.5Z","fill":"#DB0011"}));
}

SearchInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","role":"img","aria-hidden":"true","focusable":"false"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
